import React, {createContext, useContext, useEffect, useState, useMemo } from "react"
import { useLocation } from '@reach/router';
import useCookie from "./../hooks/useCookie";

import { ChildAPIContext } from './childapi'
import { UserContext } from "./usermanagement"

export const AnalyticContext = createContext(null);

const AnalyticComponent = ({children, pageTitle}) => {
	const [userConsentCookie] = useCookie(process.env.GATSBY_USER_CONSENT_COOKIE);
	const location = useLocation();
	const [analyticState, setAnalyticState] = useState();
	const value = useMemo(() => [analyticState, setAnalyticState], [analyticState]);

	const childAPIData = useContext(ChildAPIContext)
	const userStateData = useContext(UserContext)

	let rollType="anonymous"
	let loginStatus="logged-out"
	let userId="anonymous"

	if(childAPIData?.childAPI && childAPIData?.childAPI[0]?.auth_token) {
		rollType="Kid"
		loginStatus="logged-in"
		userId=childAPIData.childAPI[0].child
	} else if(userStateData && userStateData[0] && userStateData[0]?.cognito_user?.username) {
		rollType="Grown-Up"
		loginStatus="logged-in"
		userId=userStateData[0].cognito_user.username
	}

	useEffect(() => {
		const globalEvent = {
				event: 'pageview',
				rollType: rollType,
				pageName: pageTitle,
				loginStatus: loginStatus, 
				userID: userId,
				pagePath: location.pathname
			}
			// console.log(JSON.stringify(globalEvent,null,2))
			pushDataLayer(globalEvent);
	}, [])


	const pushDataLayer = (analyticsEvent) => {

		if(analyticsEvent) {

			try {
				if (typeof analyticsEvent === 'string') {
					analyticsEvent = JSON.parse(analyticsEvent)
				}

				window.dataLayer.push(analyticsEvent);
			} catch(e) {
				console.error("Error pushing to analytics", e);
			}   
		}
	}


	
	
	
	const analyticClick = (e) => {
		if (typeof window !== "undefined" && typeof window.dataLayer !== 'undefined' && Array.isArray(window.dataLayer)) {
			let item = e.target;
			let analytics = (item.dataset?.analytics)?(item.dataset.analytics):(item.parentElement.dataset.analytics);
			
			if(analytics) {
				pushDataLayer(analytics)
			}
		}
	}


  	return(
		<AnalyticContext.Provider value={value}>
			<div className="analyticClickHandler" onClick={analyticClick} >
				{children}
			</div>
		</AnalyticContext.Provider>
  	)
}

// Wrapper component
const Analytic = ({children, pageTitle}) => {
  return(
      <AnalyticComponent pageTitle={pageTitle}>
        {children}
      </AnalyticComponent>
  )
}

export default Analytic
